import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import FormInputWithLabel from '../../Components/Global_Components/form/FormInputWithLabel';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {bmiValue, handleNill, labelStyles, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './fertility_first_visit.scss';

export default function FertilityFirstVisit(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');

  const investigationHeaders = [
    {key: 'investigation', label: 'Investigation'},
    {key: 'female', label: 'Female'},
    {key: 'male', label: 'Male'}
  ];

  const [showTables, setShowTables] = useState({
    medication: true,
    investigation: true,
    semenAnalysis: true,
    surgicalHistory: true,
    medicalHistory: true,
    ovulationInduction: true,
    intrauterineInsemination: true,
    inVitroFertilization: true,
    femaleMedicalHistory: true,
    femaleSurgicalHistory: true,
    ectopicHistory: true
  });

  const semenAnalysisHeaders = [
    {key: 'year', label: 'Year'},
    {key: 'center', label: 'Center'},
    {key: 'volume', label: 'Volume (ml)'},
    {key: 'concentration', label: 'Concentration (mill/ml)'},
    {key: 'motility', label: 'Progressive Motility (%)'},
    {key: 'morphology', label: 'Morphology (%)'}
  ];

  const surgicalHistoryHeaders = [
    {key: 'year', label: 'Year'},
    {key: 'surgery', label: 'Surgery'},
    {key: 'findings', label: 'Notes/Findings'}
  ];

  const [surgicalHistoryRows, setSurgicalHistoryRows] = useState([{year: '', surgery: '', findings: ''}]);

  const [semenAnalysisRows, setSemenAnalysisRows] = useState([{year: '', center: '', volume: '', concentration: '', motility: '', morphology: ''}]);

  const medicalHistoryHeaders = [
    {
      key: 'condition',
      label: 'Conditions',
      inputType: 'select',
      options: ['Diabetes', 'Hypertension', 'TB', 'Hypothyroid', 'Hyperthyroid', 'Mumps', 'Others']
    },
    {key: 'duration', label: 'Duration'},
    {key: 'treatment', label: 'Treatment'}
  ];

  const [medicalHistoryRows, setMedicalHistoryRows] = useState([{condition: '', duration: '', treatment: ''}]);

  const ovulationInductionHeaders = [
    {key: 'year', label: 'Year'},
    {key: 'drugUsed', label: 'Drug Used'},
    {key: 'etATrigger', label: 'ET a Trigger'},
    {key: 'outcome', label: 'Outcome'}
  ];

  const [ovulationInductionRows, setOvulationInductionRows] = useState([{year: '', drugUsed: '', etATrigger: '', outcome: ''}]);

  const intrauterineInseminationHeaders = [
    {key: 'year', label: 'Year'},
    {key: 'drugUsed', label: 'Drug Used'},
    {key: 'etATrigger', label: 'ET a Trigger'},
    {key: 'outcome', label: 'Outcome'}
  ];

  const inVitroFertilizationHeaders = [
    {key: 'year', label: 'Year'},
    {key: 'center', label: 'Center'},
    {key: 'protocol', label: 'Protocol'},
    {key: 'noOfEggs', label: 'No. of Eggs/ Embryos'},
    {key: 'outcome', label: 'Outcome/Comments'}
  ];

  const [inVitroFertilizationRows, setInVitroFertilizationRows] = useState([{year: '', center: '', protocol: '', noOfEggs: '', outcome: ''}]);

  const [intrauterineInseminationRows, setIntrauterineInseminationRows] = useState([{year: '', drugUsed: '', etATrigger: '', outcome: ''}]);

  const femaleMedicalHistoryHeaders = [
    {
      key: 'condition',
      label: 'Conditions',
      inputType: 'select',
      options: ['DM', 'HT', 'THYROID', 'ASTHMA', 'TB', 'NIL']
    },
    {key: 'duration', label: 'Duration'},
    {key: 'treatment', label: 'Treatment'}
  ];

  const [femaleMedicalHistoryRows, setFemaleMedicalHistoryRows] = useState([{condition: '', duration: '', treatment: ''}]);

  const femaleSurgicalHistoryHeaders = [
    {key: 'year', label: 'Year'},
    {key: 'surgery', label: 'Surgery'},
    {key: 'findings', label: 'Notes/Findings'}
  ];

  const [femaleSurgicalHistoryRows, setFemaleSurgicalHistoryRows] = useState([{year: '', surgery: '', findings: ''}]);

  const [ectopicHistoryRows, setEctopicHistoryRows] = useState([
    {
      goutcome: '',
      modeOfConception: '',
      weeks: '',
      modeOfDelivery: '',
      babyOutcome: '',
      complications: '',
      comments: ''
    }
  ]);

  const ectopicHistoryHeaders = [
    {key: 'goutcome', label: 'G Outcome', inputType: 'select', options: ['Term', 'Preterm', 'Miscarriage', 'Ectopic']},
    {key: 'modeOfConception', label: 'Mode of Conception', inputType: 'select', options: ['Natural', 'IUI', 'IVF']},
    {key: 'weeks', label: 'Weeks', inputType: 'text'},
    {key: 'modeOfDelivery', label: 'Mode of Delivery', inputType: 'select', options: ['Vaginal', 'LSCS', 'Medical Miscarriage', 'Surgical Miscarriage']},
    {key: 'babyOutcome', label: 'Baby Outcome', inputType: 'select', options: ['Alive', 'Expired', 'Other']},
    {key: 'complications', label: 'Complications', inputType: 'select', options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other']},
    {key: 'comments', label: 'COMMENTS', inputType: 'text'}
  ];

  const [investigationRows, setInvestigationRows] = useState([
    {investigation: 'CBC', female: '', male: ''},
    {investigation: 'Blood Group', female: '', male: ''},
    {investigation: 'TSH', female: '', male: ''},
    {investigation: 'SFT3 / FT4', female: '', male: ''},
    {investigation: 'PROLACTIN', female: '', male: ''},
    {investigation: 'AMH', female: '', male: ''},
    {investigation: 'HIV, HBsAg, Anti-HCV, VDRL', female: '', male: ''},
    {investigation: 'Urea / Creatinine', female: '', male: ''},
    {investigation: 'RBS, HbA1c', female: '', male: ''},
    {investigation: 'Semen Test', female: '', male: ''},
    {investigation: 'Karyotype if necessary', female: '', male: ''},
    {investigation: 'DFI if necessary', female: '', male: ''}
  ]);

  const medicationHeaders = [
    {key: 'patient', label: 'Patient'},
    {key: 'brand', label: 'Brand Name'},
    {key: 'generic', label: 'Generic Name'},
    {key: 'dose', label: 'Dose'},
    {key: 'time', label: 'Time to Take'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'duration', label: 'Duration'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      patient: 'Female',
      brand: 'Intafol D',
      generic: 'Folic Acid + Vit D',
      dose: '1 tab',
      time: 'Morning',
      frequency: 'Daily',
      duration: '30 days'
    },
    {
      patient: 'Female',
      brand: 'Vit D3 60K',
      generic: 'Cholecalciferol',
      dose: '60,000 IU',
      time: 'Weekly with milk',
      frequency: 'Weekly',
      duration: '8 weeks'
    },
    {
      patient: 'Male',
      brand: 'Evion 400',
      generic: 'Vitamin E',
      dose: '1 cap',
      time: 'Morning & Evening',
      frequency: 'Daily',
      duration: '30 days'
    },
    {
      patient: 'Male',
      brand: 'Vit D3 60K',
      generic: 'Cholecalciferol',
      dose: '60,000 IU',
      time: 'Weekly with milk',
      frequency: 'Weekly',
      duration: '8 weeks'
    }
  ]);

  const [drugList, setDrugList] = useState(['evion', 'calcikind', 'qutacare', 'tkq']);

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        p_uhid: props.patientsData.p_uhid
      };
      props.loaderchange('true');
      const addPatient = fetchPatientDetailsUuid(payload);
      const response = await dispatch(addPatient);
      if (response.payload?.status?.code === 200) {
        const data1 = response.payload.data.data[0].gender == 'Male' ? response.payload.data.data[0] : response.payload.data.data[1];
        const data2 = response.payload.data.data[0].gender == 'Female' ? response.payload.data.data[0] : response.payload.data.data[1];
        const namePat1 = data1?.titles + ' ' + data1?.first_name + ' ' + data1?.last_name;
        const namePat2 = data2?.titles + ' ' + data2?.first_name + ' ' + data2?.last_name;

        setPatientOne_UUId(data1?.id);
        setFormData({
          ...formData,
          patientName1: namePat1,
          age1: data1?.age,
          gender1: data1?.gender,
          patientId1: data1?.p_uhid,

          patientName2: namePat2,
          age2: data2?.age,
          gender2: data2?.gender,
          patientId2: data2?.p_uhid
        });
        props.loaderchange('false');
      }
      return;
    };

    fetchData();
  }, []);

  const handleChange = e => {
    if (e.target.name === 'patientId1' || e.target.name === 'patientId2') {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data1 = response.payload.data.data[0].gender == 'Male' ? response.payload.data.data[0] : response.payload.data.data[1];
            const data2 = response.payload.data.data[0].gender == 'Female' ? response.payload.data.data[0] : response.payload.data.data[1];
            const namePat1 = data1?.titles + ' ' + data1?.first_name + ' ' + data1?.last_name;
            const namePat2 = data2?.titles + ' ' + data2?.first_name + ' ' + data2?.last_name;
            if (e.target.name === 'patientId1' || e.target.name === 'patientId2') {
              setPatientOne_UUId(data1?.id);
              setFormData({
                ...formData,

                patientName1: namePat1,
                age1: data1?.age,
                gender1: data1?.gender,
                patientId1: data1?.p_uhid,

                patientName2: namePat2,
                age2: data2?.age,
                gender2: data2?.gender,
                patientId2: data2?.p_uhid
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }

          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setFormData({
            ...formData,
            patientId1: e.target.value
          });
        }
        if (e.target.name === 'patientId2') {
          setFormData({
            ...formData,
            patientId2: e.target.value
          });
        }
      }
    } else {
      const name = e.target.name;
      const value = e.target.value;
      const id = name?.split('_')[1];
      if (name.includes('additional') || id >= 4) {
        const updatedList = [...drugList];
        updatedList[id] = value;
        setDrugList(updatedList);
      }
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (patientOne_UUId !== '' && formData.patientId1 !== '' && formData.patientId1.length === 10) {
        setshow(true);
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('fertilityFirstVistReportwrap').innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Fertility First Visit'
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='FertilityFirstVisit'>
      <div className='FertilityFirstVisit'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div className='row'>
              <div className='col-md-6' style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <FormInputWithLabel label='Patient ID' name='patientId1' value={formData.patientId1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <FormInputWithLabel label='Patient Name' name='patientName1' value={formData.patientName1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '145px 16px 300px',
                    alignItems: 'center '
                  }}>
                  <span style={{fontWeight: 600}}>Gender</span>
                  <span style={{fontWeight: 600}}>:</span>
                  <select
                    className={`createTime ${show ? 'hide' : 'show'}`}
                    onChange={e => handleChange(e)}
                    value={formData.gender1}
                    name='gender1'
                    style={{
                      border: '1px solid #ddd',
                      outline: 'none',
                      padding: '10px',
                      backgroundColor: 'white'
                    }}>
                    <option value='' disabled selected>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                    <option value='Decline to State'>Decline to State</option>
                  </select>
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.gender1}</span>
                </div>
                <FormInputWithLabel label='Age' name='age1' value={formData.age1} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
              </div>
              <div className='col-md-6' style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                <FormInputWithLabel label='Patient ID' name='patientId2' value={formData.patientId2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <FormInputWithLabel label='Patient Name' name='patientName2' value={formData.patientName2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '145px 16px 300px',
                    alignItems: 'center '
                  }}>
                  <span style={{fontWeight: 600}}>Gender</span>
                  <span style={{fontWeight: 600}}>:</span>
                  <select
                    className={`createTime ${show ? 'hide' : 'show'}`}
                    onChange={e => handleChange(e)}
                    value={formData.gender2}
                    name='gender2'
                    style={{
                      border: '1px solid #ddd',
                      outline: 'none',
                      padding: '10px',
                      backgroundColor: 'white'
                    }}>
                    <option value='' disabled selected>
                      Select Gender
                    </option>
                    <option value='Male'>Male</option>
                    <option value='Female'>Female</option>
                    <option value='Others'>Others</option>
                    <option value='Decline to State'>Decline to State</option>
                  </select>
                  <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.gender2}</span>
                </div>
                <FormInputWithLabel label='Age' name='age2' value={formData.age2} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-4 my-2'>
          <ReportFormInputWithLabel label='Occupation :' name='occupation' value={formData.occupation} required={false} onChange={handleChange} inputClassName='show' />
        </div>
        <div className='col-md-4 my-2'>
          <ReportFormInputWithLabel
            label='Referred by :'
            name='refferedBy'
            value={formData.refferedBy}
            defaultValue={props.patientsData.doctor_id}
            required={false}
            onChange={handleChange}
            inputClassName='show'
          />
        </div>

        <div className='detail'>
          <h2 className='mt-4'>FEMALE INFORMATION</h2>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Height :' name='femaleHeight' value={formData.femaleHeight} required={false} onChange={handleChange} inputClassName='show' endLabel='cm' />
            </div>

            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight :' name='femaleWeight' value={formData.femaleWeight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='BMI :'
                name='fbmi'
                value={bmiValue(formData.femaleHeight, formData.femaleWeight)}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg/m2'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Blood Pressure (BP) :'
                name='femaleBP'
                value={formData.femaleBP}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='mmHg'
                minWidth='200px'
              />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='PR :' name='femalePulse' value={formData.femalePulse} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' />
            </div>
          </div>

          <div className='row'>
            {/* <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Chief complaints :'
                name='chiefComplaints'
                value={formData.chiefComplaints}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                minWidth='160px'
              />
            </div> */}
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Married-years :' name='married_years' value={formData.married_years} required={false} onChange={handleChange} inputClassName='show' minWidth='150px' />
            </div>
            <div className='col-md-4'>
              <label className='fw-bold me-2 mt-3' style={{fontSize: '18px', minWidth: '180px'}}>
                Subfertility-years :
              </label>
              <select className={`createTime fw-bold ${show ? 'hide' : 'show'}`} name='subfertility' onChange={handleChange} style={{fontSize: '18px'}}>
                <option value='Primary' disabled selected>
                  Please select
                </option>
                <option value='Primary'>Primary</option>
                <option value='Secondary'>Secondary</option>
              </select>
            </div>
          </div>

          <h3 className='pt-3'>Menstrual H/O: </h3>
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Last Menstrual Period (LMP) :' name='lmp' value={formData.lmp} required={false} onChange={handleChange} inputClassName='show' minWidth='270px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4 '>
              <ReportFormInputWithLabel
                label='Cycle Length :'
                name='cycleLength'
                value={formData.cycleLength}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                minWidth='150px'
                endLabel='days'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{minWidth: '150px'}}>
                Cycles Pattern:
              </label>
              <select className={`createTime fw-bold ${show ? 'hide' : 'show'}`} name='cyclePattern' onChange={handleChange}>
                <option value='Primary' disabled selected>
                  Please select
                </option>
                <option value='Regular'>Regular</option>
                <option value='Irregular'>Irregular</option>
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Pain in periods:
              </label>
              <select className={`createTime ${show ? 'hide' : 'show'}`} name='pain_periods' onChange={handleChange}>
                <option value='' selected disabled>
                  Please Select
                </option>

                <option value='Yes'>Yes</option>
                <option value='No'>No</option>
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4 fw-bold' style={{fontSize: '18px'}}>
              <label className='me-2 mt-3 fw-bold' style={{fontSize: '18px', minWidth: '150px'}}>
                Need withdrawal:
              </label>
              <select className={`createTime fw-bold ${show ? 'hide' : 'show'}`} name='needs_withdrawal' onChange={handleChange}>
                <option value='' selected disabled>
                  Please Select
                </option>

                <option value='Yes'>Yes</option>
                <option value='No'>No</option>
              </select>
            </div>
          </div>
         <h3 className='mt-4'>OBSTETRIC HISTORY</h3>
          
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Gravida (G):' name='gravida' value={formData.gravida} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Para (P):' name='para' value={formData.para} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Abortions (A):' name='abortions' value={formData.abortions} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Living child :' name='livingChild' value={formData.livingChild} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Ectopic :' name='ectopic' value={formData.ectopic} required={false} onChange={handleChange} inputClassName='show' minWidth='140px' />
            </div>
          </div>
          {/* <h3 className='mt-4'>OBSTETRIC HISTORY</h3> */}
          {showTables.ectopicHistory && (
            <TemplateTable
              id='ectopicHistory'
              title=''
              headers={ectopicHistoryHeaders}
              rows={ectopicHistoryRows}
              onRowsChange={(id, newRows) => setEctopicHistoryRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('ectopicHistory', setShowTables)}
            />
          )}

          <h3 className='mt-4'>FERTILITY HISTORY</h3>
          <div className='row'>
            <div className='col-md-4' style={{fontSize: '18px'}}>
              <label className='fw-bold me-2 mt-3' style={{fontSize: '18px', minWidth: '180px'}}>
                Type of Infertility :
              </label>
              <select className={`createTime fw-bold ${show ? 'hide' : 'show'}`} name='typeOfInfertility' onChange={handleChange}>
                <option value='Primary' disabled selected>
                  Please select
                </option>
                <option value='Primary'>Primary</option>
                <option value='Secondary'>Secondary</option>
              </select>
            </div>

            <div className='col-md-8'>
              <div className='d-flex'>
                <label className='fw-bold me-2 mt-2' style={{fontSize: '18px', minWidth: '180px'}}>
                  Duration of Infertility:
                </label>
                <div className='d-flex align-items-center gap-2 fw-bold'>
                  <input type='number' name='infertilityYears' value={formData.infertilityYears} onChange={handleChange} className='createTime' placeholder='Years' min='0' />
                  <span>years</span>

                  <input type='number' name='infertilityMonths' value={formData.infertilityMonths} onChange={handleChange} className='createTime' placeholder='Months' min='0' max='11' />
                  <span>months</span>
                </div>
              </div>
            </div>
          </div>
 
        <h3 className='mt-4'>CHIEF COMPLAINTS</h3>
        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          {/* <label htmlFor='advice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            Chief Complaints
          </label> */}
          <textarea className='Textarea' placeholder='' id='complaints' name='complaints' onChange={handleChange} rows='5' cols='120' />
        </div>
          

          <h3 className='mt-4'>PREVIOUS FERTILITY TREATMENTS</h3>

          {showTables.ovulationInduction && (
            <TemplateTable
              id='ovulationInduction'
              title='a) Ovulation Induction:'
              headers={ovulationInductionHeaders}
              rows={ovulationInductionRows}
              onRowsChange={(id, newRows) => setOvulationInductionRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('ovulationInduction', setShowTables)}
            />
          )}

          {showTables.intrauterineInsemination && (
            <TemplateTable
              id='intrauterineInsemination'
              title='b) Intrauterine Insemination (IUI):'
              headers={intrauterineInseminationHeaders}
              rows={intrauterineInseminationRows}
              onRowsChange={(id, newRows) => setIntrauterineInseminationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('intrauterineInsemination', setShowTables)}
            />
          )}

          {showTables.inVitroFertilization && (
            <TemplateTable
              id='inVitroFertilization'
              title='c) In Vitro Fertilization (IVF):'
              headers={inVitroFertilizationHeaders}
              rows={inVitroFertilizationRows}
              onRowsChange={(id, newRows) => setInVitroFertilizationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('inVitroFertilization', setShowTables)}
            />
          )}

          {showTables.femaleMedicalHistory && (
            <TemplateTable
              id='femaleMedicalHistory'
              title='Female Medical History'
              headers={femaleMedicalHistoryHeaders}
              rows={femaleMedicalHistoryRows}
              onRowsChange={(id, newRows) => setFemaleMedicalHistoryRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('femaleMedicalHistory', setShowTables)}
            />
          )}

          {showTables.femaleSurgicalHistory && (
            <TemplateTable
              id='femaleSurgicalHistory'
              title='Female Surgical History'
              headers={femaleSurgicalHistoryHeaders}
              rows={femaleSurgicalHistoryRows}
              onRowsChange={(id, newRows) => setFemaleSurgicalHistoryRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('femaleSurgicalHistory', setShowTables)}
            />
          )}
        </div>

        <br />

        <div className='detail mt-3'>
          <p>
            <h2>MALE INFORMATION</h2>
          </p>

          <div className='row mt-2'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Height :' name='maleHeight' value={formData.maleHeight} onChange={handleChange} show={true} endLabel='cm' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight :' name='maleWeight' value={formData.maleWeight} onChange={handleChange} show={true} endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BMI :' name='maleBMI' value={bmiValue(formData.maleHeight, formData.maleWeight)} onChange={handleChange} show={true} endLabel='kg/m2' />
            </div>
          </div>

          <div className='row pb-2'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Blood Pressure (BP) :' name='maleBP' value={formData.maleBP} onChange={handleChange} show={true} endLabel='mmHg' minWidth='200px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='PR :' name='malePR' value={formData.malePR} onChange={handleChange} show={true} endLabel='bpm' />
            </div>
          </div>
          <p>
            Sexual dysfunction:{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='sexual_dysfunction' onChange={handleChange}>
              <option value='' selected disabled>
                Please Select
              </option>

              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.sexual_dysfunction}</span>
          </p>
          <p>
            Erectile problem:{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='erectile_problem' onChange={handleChange}>
              <option value='' selected disabled>
                Please Select
              </option>
              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.erectile_problem}</span>
          </p>
          <p>
            Ejaculate problem:{' '}
            <select className={`createTime ${show ? 'hide' : 'show'}`} name='ejaculate_problem' onChange={handleChange}>
              <option value='' selected disabled>
                Please Select
              </option>
              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.ejaculate_problem}</span>
          </p>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Others :' name='others' value={formData.others} onChange={handleChange} show={true} minWidth='160px' />
            </div>
          </div>

          <br />
        </div>

        {showTables.medicalHistory && (
          <TemplateTable
            id='medicalHistory'
            title='Male Medical History'
            headers={medicalHistoryHeaders}
            rows={medicalHistoryRows}
            onRowsChange={(id, newRows) => setMedicalHistoryRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medicalHistory', setShowTables)}
          />
        )}

        {showTables.surgicalHistory && (
          <TemplateTable
            id='surgicalHistory'
            title='Male Surgical History'
            headers={surgicalHistoryHeaders}
            rows={surgicalHistoryRows}
            onRowsChange={(id, newRows) => setSurgicalHistoryRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('surgicalHistory', setShowTables)}
          />
        )}

        {showTables.semenAnalysis && (
          <TemplateTable
            id='semenAnalysis'
            title='Previous Semen Analysis'
            headers={semenAnalysisHeaders}
            rows={semenAnalysisRows}
            onRowsChange={(id, newRows) => setSemenAnalysisRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('semenAnalysis', setShowTables)}
          />
        )}

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='BASIC MEDICATIONS:'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        {showTables.investigation && (
          <TemplateTable
            id='investigation'
            title='RECOMMENDED BASIC INVESTIGATIONS:'
            headers={investigationHeaders}
            rows={investigationRows}
            onRowsChange={(id, newRows) => setInvestigationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('investigation', setShowTables)}
          />
        )}

        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='advice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            Advice:
          </label>
          <textarea className='Textarea' placeholder='Advice...' id='advice' name='advice' onChange={handleChange} rows='4' cols='100' />
        </div>

        <p style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextappointment' onChange={handleChange} type='date' />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      {/* //*report generate ------------------------------------- */}

      <div id='generateFertilityFirstVistReport'>
        <div id='fertilityFirstVistReportwrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='firstPartner'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.patientName1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.patientId1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.gender1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.age1, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>
          <div className='secondPartner' style={{border: '1px solid black', borderRadius: '10px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', formData.patientName2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID :', formData.patientId2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.gender2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.age2, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>

          <div className='occupationToRefContainer' style={{display: 'flex', marginBottom: '10px'}}>
            {renderReportfield('Occupation :', formData.female_occupation, {
              styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
              styleLabel: {fontWeight: '600', marginRight: '5px'}
            })}

            {renderReportfield('Referred by :', props.patientsData.doctor_id ? props.patientsData.doctor_id : formData.refferedBy, {
              styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
              styleLabel: {fontWeight: '600', marginRight: '5px'}
            })}
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>FEMALE INFORMATION</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            {renderReportfield('Height :', `${formData.femaleHeight ? formData.femaleHeight : ''} cm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Weight :', `${formData.femaleWeight ? formData.femaleWeight : ''} kg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('BMI :', `${bmiValue(formData.height, formData.weight)} kg/m2`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Blood Pressure (BP) :', `${formData.femaleBP ? formData.femaleBP : ''} mm/hg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('PR :', `${formData.femalePulse ? formData.femalePulse : ''} bpm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {/* {renderReportfield('Chief complaints :', formData.chiefComplaints, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })} */}
            {renderReportfield('Married-years :', formData.married_years, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Subfertility-years :', formData.subfertility, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 500, marginRight: '5px'}}>Menstrual H/O</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Last Menstrual Period (LMP) :', formData.lmp, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Cycle Length :', `${formData.cycleLength ? formData.cycleLength : ''} days`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Cycles Pattern :', formData.cyclePattern, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Pain in Periods :', formData.pain_periods, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Need Withdrawal :', formData.needs_withdrawal, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 500, marginRight: '5px'}}>OBSTETRIC HISTORY</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Gravida (G) :', formData.gravida, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Para :', formData.para, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Abortions (A) :', formData.abortions, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Living child :', formData.livingChild, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Ectopic :', formData.ectopic, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          {showTables.ectopicHistory && (
            <div style={{marginTop: '10px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
              <h5 style={{fontWeight: 600, marginBottom: '15px'}}>Detailed Obstetric History</h5>
              <table style={{width: '100%', border: '1px solid black', borderCollapse: 'collapse'}}>
                <thead>
                  <tr>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>G Outcome</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Mode of Conception</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Weeks</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Mode of Delivery</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Baby Outcome</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Complications</th>
                    <th style={{border: '1px solid black', padding: '8px', backgroundColor: '#f5f5f5'}}>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {ectopicHistoryRows.map((row, index) => (
                    <tr key={index}>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.goutcome}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.modeOfConception}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.weeks}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.modeOfDelivery}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.babyOutcome}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.complications}</td>
                      <td style={{border: '1px solid black', padding: '8px'}}>{row.comments}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 500, marginRight: '5px'}}>FERTILITY HISTORY</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Type of Infertility :', formData.typeOfInfertility, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Duration of Infertility (Years) :', formData.infertilityYears, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Months :', formData.infertilityMonths, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>
          
          <div style={{marginTop: '10px', display: 'flex'}}>
            <h4 style={{fontWeight: 500, marginRight: '5px'}}>CHIEF COMPLAINTS</h4>
          </div>
          <div style={{marginBottom: '10px', wordBreak: 'break-word'}}>{renderReportfield(formData.complaints)}</div>

          <h4 style={{fontWeight: 600, marginRight: '5px'}}>PREVIOUS FERTILITY TREATMENTS</h4>
          {showTables.ovulationInduction &&
            renderDynamicTable('a) Ovulation Induction:', ['Year', 'Drug Used', 'ET a Trigger', 'Outcome'], ['year', 'drugUsed', 'etATrigger', 'outcome'], ovulationInductionRows)}

          {showTables.intrauterineInsemination &&
            renderDynamicTable('b) Intrauterine Insemination (IUI):', ['Year', 'Drug Used', 'ET a Trigger', 'Outcome'], ['year', 'drugUsed', 'etATrigger', 'outcome'], intrauterineInseminationRows)}

          {showTables.inVitroFertilization &&
            renderDynamicTable(
              'c) In Vitro Fertilization (IVF):',
              ['Year', 'Center', 'Protocol', 'No. of Eggs/ Embryos', 'Outcome/Comments'],
              ['year', 'center', 'protocol', 'noOfEggs', 'outcome'],
              inVitroFertilizationRows
            )}

          {showTables.femaleMedicalHistory && renderDynamicTable('Female Medical History', ['Conditions', 'Duration', 'Treatment'], ['condition', 'duration', 'treatment'], femaleMedicalHistoryRows)}

          {showTables.femaleSurgicalHistory && renderDynamicTable('Female Surgical Histor', ['Year', 'Surgery', 'Notes/Findings'], ['year', 'surgery', 'findings'], femaleSurgicalHistoryRows)}

          <div style={{display: 'flex', marginTop: '20px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>MALE INFORMATION</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '10px'}}>
            {renderReportfield('Height :', `${formData.maleHeight ? formData.maleHeight : ''} cm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Weight :', `${formData.maleWeight ? formData.maleWeight : ''} kg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('BMI :', `${bmiValue(formData.maleHeight, formData.maleWeight)} kg/m2`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}

            {renderReportfield('BP :', `${formData.maleBP ? formData.maleBP : ''} mmHg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('PR :', `${formData.malePR ? formData.malePR : ''} bpm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Sexual dysfunction :', formData.sexual_dysfunction, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}

            {renderReportfield('Erectile problem :', formData.erectile_problem, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Ejaculate problem :', formData.ejaculate_problem, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Others :', formData.others, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          {showTables.medicalHistory && renderDynamicTable('Male Medical History', ['Conditions', 'Duration', 'Treatment'], ['condition', 'duration', 'treatment'], medicalHistoryRows)}

          {showTables.surgicalHistory && renderDynamicTable('Male Surgical history', ['Year', 'Surgery', 'Notes/Findings'], ['year', 'surgery', 'findings'], surgicalHistoryRows)}

          {showTables.semenAnalysis &&
            renderDynamicTable(
              'PREVIOUS SEMEN ANALYSIS',
              ['Year', 'Center', 'Volume (ml)', 'Concentration (mill/ml)', 'Progressive Motility (%)', 'Morphology (%)'],
              ['year', 'center', 'volume', 'concentration', 'motility', 'morphology'],
              semenAnalysisRows
            )}

          {showTables.medication &&
            renderDynamicTable(
              'BASIC MEDICATIONS',
              ['Patient', 'Brand', 'Generic', 'Dose', 'Time', 'Frequency', 'Duration'],
              ['patient', 'brand', 'generic', 'dose', 'time', 'frequency', 'duration'],
              medicationRows
            )}

          {showTables.investigation &&
            renderDynamicTable(
              'RECOMMENDED BASIC INVESTIGATIONS',
              ['Investigation', 'Female', 'Male'],
              ['investigation', 'female', 'male'],
              investigationRows
            )}

          <div style={{display: 'flex'}}>
          <p style={{fontWeight: 600, marginRight: '5px'}}>Advice:</p>
          </div>
          <div style={{marginBottom: '10px',wordBreak: 'break-word',}}>{renderReportfield(formData.advice)}</div>

          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment', appointmentData.date?.split('-').reverse().join('-'))}</div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}